import { render, staticRenderFns } from "./PlaceDocumentChip.vue?vue&type=template&id=482b3cd5"
import script from "./PlaceDocumentChip.vue?vue&type=script&lang=js"
export * from "./PlaceDocumentChip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports